module.exports = __webpack_public_path__ + "static/media/icon_travel.d79559ea.svg";